// extracted by mini-css-extract-plugin
export var button = "Button-module--button--Z_eik";
export var primary = "Button-module--primary--1DJj_";
export var signupForm = "Button-module--signupForm--_zEiu";